import styled from 'styled-components';
import { headlineFontFamily } from 'assets/styles/fonts';

export const Headline3 = styled.h3`
  font-size: ${({ theme }) => theme.fonts.headline3FontSize};
  ${headlineFontFamily};
`;
